import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export async function apiUserExists(email: string): Promise<boolean> {
  const response = await occFetch(occUrl(`/registered-user/exists/${encodeURIComponent(email)}`), {
    method: "GET",
    headers: {
      dataType: "json",
      "content-type": "application/json",
    },
  });

  const data = await response.json();
  return data;
}
